import {
  Align,
  Arrange,
  Container,
  Icon,
  Spacer,
  Text,
  Tooltip,
} from '@loomhq/lens';
import cn from 'classnames';
import React, { forwardRef, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { DestinationContext } from 'contexts/DestinationContext';

import { FadeRoot, FadeText } from './FadeText';

import styles from './styles.module.less';

const MenuIcon = ({ collapsed, icon, count }) => {
  return (
    <>
      {collapsed && count > 0 && (
        <div className={styles.bubble}>
          <Container backgroundColor="record" height="small" width="small" />
        </div>
      )}
      <Icon icon={icon} color="currentColor" />
    </>
  );
};

const MenuLink = forwardRef(
  (
    {
      title,
      url,
      icon,
      collapsed,
      count,
      shouldShowFTUXTooltip,
      onClick,
      isReactRouterLink,
      shouldDim,
      className,
      actionElement,
      isBeta,
    },
    ref
  ) => {
    const location = useLocation();
    const isActive = (location.pathname + '/').startsWith(url + '/');
    const isInDestinationRoute = useContext(DestinationContext);

    const linkProps = {
      ref,
      className: cn(
        styles.menuItem,
        shouldShowFTUXTooltip && styles.hasFTUXTooltip,
        shouldDim && styles.shouldDim,
        className
      ),
      'aria-current': isActive ? 'page' : undefined,
      onClick,
      children: (
        <Arrange justifyContent="space-between">
          <FadeRoot className={styles.menuItemInner}>
            {icon && (
              <MenuIcon icon={icon} count={count} collapsed={collapsed} />
            )}
            <Spacer right="small" />
            <FadeText visible={!collapsed}>
              <Text className={styles.linkTitle} hasEllipsis>
                {title}
                {isBeta && <span className={styles.betaLinkTitle}>Beta</span>}
              </Text>
            </FadeText>
          </FadeRoot>
          {!collapsed && count > 0 && (
            <div className={styles.count}>
              <Container
                backgroundColor="record"
                minWidth="large"
                height="large"
                paddingX="small"
              >
                <Align alignment="center">
                  <Text color="white" fontWeight="medium">
                    {count >= 99 ? '99+' : count}
                  </Text>
                </Align>
              </Container>
            </div>
          )}
          {!collapsed && actionElement}
        </Arrange>
      ),
    };

    const content =
      isReactRouterLink && isInDestinationRoute ? (
        <Link {...linkProps} to={url} />
      ) : (
        <a {...linkProps} href={url} />
      );

    return (
      <Tooltip
        content={collapsed ? title : null}
        isInline={false}
        placement="rightCenter"
      >
        {content}
      </Tooltip>
    );
  }
);

export default MenuLink;
